import axiosInstance from "../../axios/axiosInstance";
import { MARK_AS_READ_NOTIFICATION_URL, NOTIFICATION_LISTING } from "../../constants";

export const getNotificationListing = (props) => onResponse => {

    const page = props?.page ? props?.page : ""
    const limit = props?.limit ? props?.limit : ""

    let BASE_URL = NOTIFICATION_LISTING + `?page=${page}&pageSize=${limit}`

    try {
        axiosInstance.post(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const markAsReadNotification = (id) => onResponse => {
    try {
        axiosInstance.post(MARK_AS_READ_NOTIFICATION_URL, { notificationId: id })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};